// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-top[data-v-dc2f5ec4] {\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n[data-v-dc2f5ec4] .vxe-header--column .vxe-cell--title {\n  line-height: inherit !important;\n}\n", ""]);
// Exports
module.exports = exports;
